const action = "WORKSPACE_FETCH_LLM";
export const REQUEST = action+'_REQUEST';
export const RESPONSE = action+'_RESPONSE';
export const CLEAR = action+'_CLEAR';
export const FAILURE = action+'_FAILURE';

export const fetchRequest = (payload) => {
    return {
        type: REQUEST,
        payload
    };
};
export const fetchSuccess = (response) => ({
  type: RESPONSE,
  payload: response
});

export const clearState = (response) => ({
  type: CLEAR
});

export const fetchFailure = (error) => ({
  type: FAILURE,
  payload: error
});
